module.exports = __webpack_public_path__ + "img/32.94cec8cd.jpg";